import _styled from "styled-components";
var _excluded = ["label"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';

var CheckboxBimAdapter = function CheckboxBimAdapter(_ref) {
  var label = _ref.label,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (label) {
    return /*#__PURE__*/React.createElement(_StyledLabel, {
      $_css: [{
        display: 'flex',
        alignItems: 'center',
        '& span': {
          paddingLeft: '7px'
        }
      }]
    }, /*#__PURE__*/React.createElement(Checkbox, rest), /*#__PURE__*/React.createElement("span", null, label));
  }

  return /*#__PURE__*/React.createElement(Checkbox, rest);
};

CheckboxBimAdapter.propTypes = {
  /** The label of the checkbox */
  label: PropTypes.node
};
export default CheckboxBimAdapter;

var _StyledLabel = _styled("label").withConfig({
  displayName: "CheckboxBimAdapter___StyledLabel",
  componentId: "sc-1uy06ws-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=CheckboxBimAdapter.js.map